import React from 'react';
import { Button, Checkbox, Form, Input } from 'antd';
import { UserFormValues } from '../types';

const rules = [{ required: true, message: 'Wajib diisi' }];

const UserForm = ({
  loading,
  initialValues,
  onSubmit,
}: {
  loading: boolean;
  initialValues?: UserFormValues;
  onSubmit: (values: UserFormValues) => void;
}) => {
  return (
    <Form
      name="userForm"
      layout="vertical"
      onFinish={onSubmit}
      initialValues={{ isInternal: false, ...initialValues }}
    >
      <Form.Item label="Name" name="name" rules={rules}>
        <Input placeholder="Name" />
      </Form.Item>
      <Form.Item label="Username" name="username" rules={rules}>
        <Input placeholder="Username" />
      </Form.Item>
      {!initialValues ? (
        <Form.Item label="PIN" name="pin" rules={rules}>
          <Input.Password placeholder="PIN" />
        </Form.Item>
      ) : null}
      <Form.Item name="isInternal" valuePropName="checked" label={null}>
        <Checkbox>Internal?</Checkbox>
      </Form.Item>
      <Button type="primary" htmlType="submit" loading={loading}>
        Submit
      </Button>
    </Form>
  );
};

export default UserForm;
